import React from 'react';

const LogoCircleMenu = (props) => (
    <div className="circle-menu">
        <svg
            version="1.1"
            id="Componente_32_30"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="-1 0 37 42.5"
            style={{ enableBackground: 'new 0 0 31 51' }}
            xmlSpace="preserve">

            <g transform="matrix(1, 0, 0, 1, 0, 0)">
                <path
                    id="Trazado_937-2"
                    className="st0"
                    d="M26.6,56.8c-0.1-1.9-0.7-3.7-1.8-5.2l0,0l0,0c-0.3-0.3-0.6-0.7-0.9-1
                    c-1.4-1.6-3.8-5-3.9-8.7c0-4.4,4.6-9,7.3-11.2c0.6-0.4,1.2-0.9,1.8-1.4l0,0l0,0l0.2-0.2c2-1.8,3.4-4,4.3-6.5
                    c3-8.6-1.5-18.1-10.1-21.1c0-0.1-0.1-0.1-0.2-0.1C14.5-1.7,4.9,2.8,1.6,11.5c-2.4,6.7-0.2,14.3,5.5,18.6l0,0h0.1
                    c0.2,0.2,0.4,0.3,0.6,0.4c1.9,1.4,6.8,5.7,6.9,11.3c0,3.4-1.1,6.8-3.2,9.5c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.2,0.2-0.2,0.2l0,0
                    c-0.5,0.6-0.8,1.3-1.1,2c-0.3,1-0.5,2-0.5,3C9.3,57,26.6,57,26.6,56.8z"
                    fill="#00161D"
                    stroke="#FFFFFF"
                    strokeWidth="1.301"
                    strokeMiterlimit="4.0008"
                />
            </g>
        </svg>
    </div>

);

export default LogoCircleMenu;
